import React, { useState } from "react";
import styles from "./index.module.css";
import Loader from "../../components/Loader";
import SimpleSearchInput from "../../components/SimpleSearchInput";
import MaterialIconsReact from "material-icons-react";
import { fetchImageList, fetchImosCsv } from "../../services/qcService";
import { Box, Tab, Tabs } from "@mui/material";

export default function ImageSearch() {
  const [value, setValue] = React.useState(0);
  const [response, setResponse] = useState({
    loading: false,
    data: [],
    error: null,
    currentPOCode: null,
  });

  const fetchImagesForPO = async (code) => {
    setResponse((prev) => ({
      ...prev,
      loading: true,
      error: null,
      data: [],
      currentPOCode: code,
    }));
    try {
      const images = await fetchImageList(code);
      setResponse((prev) => ({ ...prev, data: images.message }));
    } catch (error) {
      setResponse((prev) => ({
        ...prev,
        error: "Error fetching images. Please check PO code or try again later",
      }));
    } finally {
      setResponse((prev) => ({ ...prev, loading: false }));
    }
  };

  const downloadImosCSV = async (code) => {
    setResponse((prev) => ({
      ...prev,
      loading: true,
      error: null,
      data: [],
      currentPOCode: code,
    }));
    try {
      const imosData = await fetchImosCsv(code);
      const url = window.URL.createObjectURL(new Blob([imosData])) 
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `IMOS_${code}.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      resetState();
      // setResponse((prev) => ({ ...prev, data: images.message }));
    } catch (error) {
      setResponse((prev) => ({
        ...prev,
        error: "Error fetching IMOS Csv file. Please check PO code or try again later",
      }));
    } finally {
      setResponse((prev) => ({ ...prev, loading: false }));
    }
  };

  const resetState = () => {
    setResponse((prev) => ({
      ...prev,
      loading: false,
      error: null,
      data: [],
      currentPOCode: null,
    }));
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#fff' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Image Search" />
          <Tab label="IMOS CSV Download" />
        </Tabs>
      </Box>
      <div style={{ padding: 20 }}>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            height: "90vh",
            padding: 20,
            overflow: "scroll",
          }}
        >
          {response.data && response.data.length ? (
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <MaterialIconsReact
                  icon="arrow_back"
                  size={20}
                  onClick={resetState}
                />
                <h3 style={{ marginLeft: 20 }}>{response.currentPOCode}</h3>
              </div>
              <div className={styles.cardHeader}>
                <h3>Panel images</h3>
              </div>
              <div className={styles.imageListWrapper}>
                {response.data.map((item) => {
                  return (
                    <div key={item.file_name} className={styles.imageContainer}>
                      <img
                        src={item.pre_signed_url}
                        className={styles.imageBox}
                        alt={`Panel ${item.file_name}`}
                      />
                      <div className={styles.footer}>{item.file_name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={require("../../assets/file_search.png")}
                  height={150}
                  width={150}
                  alt="File Search"
                />
                {response.currentPOCode && response.data.length === 0 ? (
                  <h3 style={{ color: "#DB382A" }}>
                    {`No ${value === 1 ? 'CSV file' : 'images'} found. Try with different PO`}
                  </h3>
                ) : (
                  <h3>{`Search for ${value === 1 ? 'IMOS CSV' :'archived POs images'}`}</h3>
                )}
                <SimpleSearchInput
                  placeholder={"Search by PO code"}
                  onEnter={(poCode) => {
                    if (value === 0) {
                      fetchImagesForPO(poCode);
                    } else {
                      downloadImosCSV(poCode)
                    }
                  }}
                />
                <div style={{ height: 20 }} />
                {response.loading ? <Loader tip="Searching for POs" /> : null}
                {response.error ? <h5>{response.error}</h5> : null}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
